import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import {environment} from "../../environments/environment";
import {Sysuser} from '../models/sysuser';
;


@Injectable({
  providedIn: 'root'
})
export class SysUserService {

constructor(private http: HttpClient ) { }




public getAllOrSearchUsers(searchString: string, page: number, pageSize: number, mechanicIds?: string){

    if (mechanicIds != null && mechanicIds.trim() != "") {
        return this.getUsersByIds(mechanicIds, page, pageSize);
    }
    else if(searchString != null &&  searchString.trim() != ""){
        return  this.searchSystemUsers(searchString,page ,pageSize);
    }
    else{
        return  this.getSystemUsers(page ,pageSize);
    }

}

public getSystemUsers(page: number, pageSize: number): Observable<Sysuser[]> {
    return this.http.get<Sysuser[]>(environment.APIENDPOINT + '/users?page='+page+'&size='+pageSize, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }

  public getUsersByIds(ids: string, page: number, pageSize: number): Observable<Sysuser[]> {
    return this.http.get<Sysuser[]>(environment.APIENDPOINT + '/users?ids=' + encodeURIComponent(ids) + '&page=' + page + '&size=' + pageSize, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }

  public searchSystemUsers(searchString: string , page: number, pageSize: number): Observable<Sysuser[]> {
    return this.http.get<Sysuser[]>(environment.APIENDPOINT + '/users/search?searchString='+searchString+'&page='+page+'&size='+pageSize, {
      headers: this.setHeaders(),
      responseType: 'json'
    });
  }

    public addSystemUsers(user: Sysuser) {

        return this.http.post(environment.APIENDPOINT + "/users", user,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );

    }

    public updateSystemUsers(user: Sysuser) {
        return this.http.post(environment.APIENDPOINT + "/users", user,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );
    }

    public changeUserStatus(userId: number, statusCodeNeedToChange: string) {
        return this.http.post(environment.APIENDPOINT + "/users/" + userId + "?statusCodeNeedToChange=" + statusCodeNeedToChange, null,
            {
                headers: this.setHeaders(),
                responseType: 'json'
            }
        );
    }



  private setHeaders() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let userTenant = localStorage.getItem('userTenant');
    let authHeader = new HttpHeaders({'Authorization': 'Bearer ' + currentUser.token , 'X-Tenant' : userTenant });
    return authHeader;
  }



}


